import React from 'react';
import Asset from '../../requests/apa/Asset';
import Utils from "../../utils/Utils";
import { ColoredButton } from '../../packages/components/lib/ColoredButton';
import { Tab } from '../../packages/components/lib/Keyboard/Tab';
import { Button } from '../../packages/components/lib/Button';
import {
  RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO,
  RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO_TAB,
  RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO_TAB_ACTIVE,
} from '../../packages/components/lib/utils/classes.ts';
import {
  INITIAL_ID_PLAN_SELECTOR_BUTTON_BLUE,
  PLANSELECTOR,
  ROOT_ID_PLAN_SELECTOR_CARD
} from '../../components/RibbonNew/constants';
import cls from '../../packages/components/lib/utils/classnames';


function focusHandler(focusHandlerCallBack, data) {
  if (window.setResumeData) window.setResumeData(data);
  return typeof focusHandlerCallBack === 'function' ? focusHandlerCallBack(data) : null;
}

function keyUpHandler(keyUpHandlerCallBack, props) {
  return typeof keyUpHandlerCallBack === 'function' ? keyUpHandlerCallBack(props) : null;
}

function keyDownHandler(e, keyDownHandlerCallBack, params) {
  return typeof keyDownHandlerCallBack === 'function' ? keyDownHandlerCallBack(e, params) : null;
}

function createBadge(badge, extraSpace = false) {
  return badge !== '' ? (
    <div className={`box-badge-styles ${extraSpace ? 'extra-space' : ''}`} dangerouslySetInnerHTML={{ __html: badge }}></div>
  ) : '';
}

function getPlaceholder(type) {
  let placeholder = null;

  switch (type) {
    case 'highlight':
      placeholder = Asset.get(
        'asset_placeholder_highlight',
        '/images/placeholder_highlight.png'
      );
      break;
    case 'landscape':
      placeholder = Asset.get(
        'asset_placeholder_landscape',
        '/images/placeholder_landscape.png'
      );
      break;
    case 'portrait':
      placeholder = Asset.get(
        'asset_placeholder_portrait',
        '/images/placeholder_portrait.png'
      );
      break;
    case 'user-profile':
    case 'user-info':
      placeholder = Asset.get(
        'placeholder_talent_movie',
        '/images/placeholder_talent_movie.png'
      );
      break;
    case 'cd':
    case 'square':
    case 'circle':
      placeholder = Asset.get('asset_placeholder_square', '/images/placeholder_square.png');
      break;
    case 'actor':
    case 'casting':
    case 'costume designer':
    case 'original music':
    case 'production design':
    case 'screenwriter':
    case 'set decoration':
    case 'art director':
    case 'supervising art direction':
    case 'executive producer':
    case 'film editor':
    case 'cinematographer':
    case 'producer':
    case 'talent':
    case 'narrator':
    case 'voice':
    case 'director':
    case 'writer':
    case 'conductor':
      placeholder = Asset.get(
        'content_data_talent_placeholder',
        '/images/content_data_talent_placeholder.png'
      );
      break;
    default:
      placeholder = Asset.get(
        'asset_placeholder_landscape',
        '/images/placeholder_landscape.png'
      );
  }

  return placeholder;
}

function getUri(href, group_id, data, ignoreSeenLast) {
  href = data.href || data.src || `/vcard/${group_id || ''}`;

  if (data.live_enabled == '1') {
    href = `/player/${group_id}`;
  }

  if (href.indexOf('/vcard/') !== -1) {
    href = `${href}${ignoreSeenLast ? '/1' : ''}`;
  }

  if (data.type === PLANSELECTOR) {
    href = `/detailtransaction`;
  }

  return href;
}

function getRedirectPlanSelector(history, linkTo, pbi) {
  console.log('CardPlanSelector getRedirectPlanSelector:::::', history, linkTo, pbi);
  // history.push(`/detailtransaction`, { ...pbi, from: 'plan-selector' });
  // console.log('CardPlanSelector getRedirectPlanSelector return:::::', history);

  return history.push(linkTo, { ...pbi, from: 'plan-selector' });
  // return history.push({
  //   pathname: linkTo,
  //   state: { ...pbi, from: 'plan-selector' }
  // });
}

function createSibling(sibling) {
  const siblingComponent = (
    <div className="placeholder-container">
      <div className="sibling-wrapper">
        <div
          className="card-placeholder"
          style={{ backgroundImage: `url(${this.getPlaceholder('portrait')})` }}
          alt="placeholder"
        />
        <img className="card-cover" src={sibling} />
      </div>
      <div className="arrow-right" />
    </div>
  );

  return sibling ? siblingComponent : null;
}

function createTitle(title, showTitle, isChannel = false) {
  const titleComponent = <div className="card-title">
    <span className="title-bottom">{title}</span>
  </div>;

  return !isChannel && title && title.length && showTitle ? titleComponent : null;
}

function createSubTitle(subTitle) {
  const titleComponent = <div className="card-subtitle">
    <span className="subtitle-bottom">{subTitle}</span>
  </div>;

  return subTitle.length ? titleComponent : null;
}

function createLabel(label) {
  const span = <div className="card-label"
    dangerouslySetInnerHTML={{ __html: label }} />;

  return label.length ? span : null;
}

function posterTitleIsEnabled(provider = 'default', display = 'landscape') {

  if(typeof provider !== 'string') return false;

  provider = provider.toLowerCase().split(' ').join('');
  let poster_title_configuration = Utils.getAPARegionalized('poster_title_configuration', provider, {
    "default": { "portrait": true, "landscape": true },
    "amco": { "portrait": false, "landscape": false },
    "fox": { "portrait": true, "landscape": true },
    "hbo": { "portrait": true, "landscape": true },
    "noggin": { "portrait": true, "landscape": true },
    "picardia": { "portrait": true, "landscape": true },
    "edye": { "portrait": true, "landscape": true },
    "paramount": { "portrait": true, "landscape": true },
    "stingrayqello": { "portrait": true, "landscape": true },
    "stingraykaraoke": { "portrait": true, "landscape": true },
    "atresplayer": { "portrait": true, "landscape": true }
  });
  if (poster_title_configuration[display]) {
    return poster_title_configuration[display];
  }
  poster_title_configuration = poster_title_configuration[provider] ? poster_title_configuration[provider] : poster_title_configuration['default'];
  return poster_title_configuration && poster_title_configuration[display] ? poster_title_configuration[display] : false;
}

function createPlayerIcon() {
  return (
    <div className={'player-icon'}>
      <img src={Asset.get('content_playing_option_button_play', '')} alt="player icon" />
    </div>
  );
}

function createProgressBar(bookmark, hasPlayerIcon) {
  if (bookmark && bookmark !== '0') {
    return (
      <div>
        {bookmark && bookmark !== '0' && (
          <div className={`progress-bar-container-card ${hasPlayerIcon ? 'reduce-bar' : ''}`}>
            <div className="progress-bar" style={bookmark && Number(bookmark) >= 0 && Number(bookmark) <= 100 ? { width: bookmark + '%' } : {}}></div>
          </div>
        )}
        {hasPlayerIcon && (createPlayerIcon())}
      </div>
    );
  }
}

function createDeleteIcon() {
  return (
    <span className={'delete-action-icon'}>
        <span className="color-ball red" />
        <i className="fa fa-trash-o" />
      </span>
  );
}

function createFooter(showTrashButton, showActions, isTitleEnable = false) {
  if (showTrashButton && showActions) {
    return (
      <div className="card-title">
        <span className={`footer-actions ${isTitleEnable ? 'fix-top-icon' : ''}`}>
        {createDeleteIcon()}
      </span>
      </div>
    );
  }
}

//* Plan Selector - Creacion de boton de que incluye
function createButtonPlanSelector(idCardButtonRibbonPlanSelector, groupId, params) {
  console.log('CardPlanSelector createButtonPlanSelector:::::', idCardButtonRibbonPlanSelector, groupId, params);

  if (!params || !params.textButtonFeatures2) {
    return null;
  }

  const { buttonBackgroundFeatures, textButtonFeatures1, textButtonFeatures2 } = params;

  console.log('CardPlanSelector createButtonPlanSelector:::::', buttonBackgroundFeatures, textButtonFeatures1, textButtonFeatures2);
  return (
    <div className={RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO}>
        <Tab
          id={idCardButtonRibbonPlanSelector}
          className={cls(`${RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO_TAB} ${RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO_TAB_ACTIVE} focusable`)}
          onclick={() => {
            console.log('se dio click en tab - CardPlanSelector createButtonPlanSelector:::::', params);
          }}
      >
          <div className='container-button-include'>
              <ColoredButton
                  color="blue"
                  classSizeHotkey="large"
                  className={'access_option_button_blue'}
                  onClick={() => {
                      console.log('se dio click CardPlanSelector createButtonPlanSelector:::::', params);
                  }}
                  // style={getPlanSelectorCharacterStyleByButtonInludes(TextoBotonIncluye3)}
              >
                  <div className='button-include'>
                      {/* ¿QUE INCLUYE? */}
                      {/* Hacer validacion de texto 2 sino se pone texto 1 */}
                      {textButtonFeatures2 !== 'No hay datos' ? textButtonFeatures2 : ' '}
                  </div>
              </ColoredButton>
          </div>
      </Tab>


    </div>
  )
}

//* Plan Selector - Creacion de boton de oferta "SUSCRIBETE"
function createButtonOfferPlanSelector(params) {
  console.log('CardPlanSelector createButtonOfferPlanSelector:::::', params);

  if (!params || !params.textButton1) {
    return null;
  }

  const { buttonBackgroundOffer, textButton1 } = params;
  console.log('CardPlanSelector createButtonOfferPlanSelector:::::', typeof textButton1);
  console.log('CardPlanSelector createButtonOfferPlanSelector:::::', buttonBackgroundOffer, textButton1.text);
  return (
    <div className="container-button-offer-plan-selector">
      <Button
          style={{
            //* Actualmente trae el hexadecimal erroneo: #fffff en lugar de #ffffff
              backgroundColor: buttonBackgroundOffer,
              color: textButton1.color
          }}
          type="button"
        >
          <span> {textButton1.text} </span>
      </Button>
    </div>
  );
}

//* Plan Selector - Creacion de contenedor de titulos "OFERTAS"
function createContainerTitlesPlanSelector(params) {
  console.log('CardPlanSelector createContainerTitlesPlanSelector:::::', params);
  const { textTemporality, textPrice, textTaxes, ...textObject } = params;
  console.log('CardPlanSelector createContainerTitlesPlanSelector:::::', textObject);
  console.log('CardPlanSelector createContainerTitlesPlanSelector:::::', textTemporality, textTaxes);
  return (
    <div className="container-texts-plan-selector">
      <div className="container-text-price">
        <span className="text-price">{textPrice}</span>
        <span className="text-temporality">{textTemporality}</span>
      </div>
      <span className="text-taxes">{textTaxes}</span>
     <div className="container-text-offers">
      <span className="text-offer1">{textObject.textOffer1}</span>
      <span className="text-offer2">{textObject.textOffer2}</span>
      <span className="text-offer3">{textObject.textOffer3}</span>
     </div>
      {createButtonOfferPlanSelector(params)}
    </div>
  );
}

//* Plan Selector - Creacion de logo de plan ""
function createLogoPlansAddOn(logoAddOn) {
  console.log('CardPlanSelector createLogoPlansAddOn:::::', logoAddOn);
  if (logoAddOn) {
    return (
      <img className='logo-addOn' src={logoAddOn} alt="logo" />
    );
  }
}

//* Plan Selector - Creacion del plan selector
function createFooterPlanSelector(params) {
  console.log('CardPlanSelector createFooterPlanSelector:::::', params);
  return (
    <div className="card-container-titles">
      {createContainerTitlesPlanSelector(params)}
    </div>
  );
}

function fillZeroLeft(num, size) {
  if (!num) return '';
  num = num.toString();
  while (num.length < size) num = "0" + num;

  return num;
}

function getTimeProgress(startUnixtime, endUnixtime) {
  let justNow = Utils.nowAsTimestampSeconds();
  let progress = 0;
  // console.log('PGRESS ', justNow, startUnixtime, endUnixtime);
  if (startUnixtime <= justNow && endUnixtime > justNow) {
    const duration = endUnixtime - startUnixtime;
    let limit_forward = endUnixtime - justNow;
    let dur_limit_forward = endUnixtime - startUnixtime - limit_forward;
    const percent = dur_limit_forward > 0 ? (dur_limit_forward * 100) / duration : 0;
    progress =  percent <= 100 ? percent : 100;
  }
  // console.log('PGRESS: ', progress, '%');

  return progress;
}

//* Función para verificar si la URL es una imagen válida
function isValidImageUrl(url) {
  //* Expresión regular para verificar si la URL termina con una extensión de imagen común
  const imageExtensions = /\.(jpg|jpeg|png|gif)$/i;

  console.log('CardPlanSelector isValidImageUrl 02:::::', imageExtensions.test(url));
  return imageExtensions.test(url);
}

//* Plan Selector - Creacion del plan selector
function createFooterPlanSelector(params) {
  return (
    <div className="card-container-titles">
      {createContainerTitlesPlanSelector(params)}
    </div>
  );
}

//* Plan Selector - Creacion de logo de plan selector
function createLogoPlansAddOn(logoAddOn) {
  if (logoAddOn && logoAddOn.indexOf('http') !== -1) {
    return (
      <img className='logo-addOn' src={logoAddOn} alt="logo" />
    );
  }
  return null;
}

//* Plan Selector - Creacion de contenedor de titulos "OFERTAS"
function createContainerTitlesPlanSelector(params) {
  const { textPrice, textTemporality, textBonus } = params;
  const { label } = textPrice;
  const { labelPeriodicity, labelTax } = textTemporality;

  return (
    <div className="container-texts-plan-selector">
      <div className="container-text-price">
        <span className="text-price">{label}</span>
        <span className="text-temporality">{labelPeriodicity}</span>
      </div>
    <div className="container-text-iva">
      <span className="text-taxes">{labelTax}</span>
    </div>
     <div className="container-text-offers">
     {textBonus.text1 !== '' && (<span className="text-offer1">{textBonus.text1} </span>)}
     {textBonus.text2 !== '' && <span className="text-offer2"> {textBonus.text2} </span>}
     {textBonus.text3 !== '' && <span className="text-offer3">{textBonus.text3}</span>}
     </div>
      {createButtonOfferPlanSelector(params)}
    </div>
  );
}

//* Plan Selector - Creacion de boton de oferta "SUSCRIBETE"
function createButtonOfferPlanSelector(params) {
  const { buttonTextColorHex, buttonBGColorHex, buttonText,  buttonText2} = params;

  return (
    <div className="container-button-offer-plan-selector">
      {buttonText && !buttonText2 && <Button
                                        style={{
                                            backgroundColor: buttonBGColorHex,
                                            color: buttonTextColorHex
                                        }}
                                        type="button"
                                      >
                                        <span> {buttonText} </span>
                                    </Button>
      }
      {buttonText && buttonText2 && <Button
                                          style={{
                                              backgroundColor: buttonBGColorHex,
                                              color: buttonTextColorHex
                                          }}
                                          type="button"
                                        >
                                          <span className = 'spanTwoText'> {buttonText} </span>
                                          <span className = 'spanTwoText'> {buttonText2} </span>
                                      </Button>
                                  }
    </div>
  );
}

//* Plan Selector - Creacion de boton de que incluye
function createButtonPlanSelector(idCardButtonRibbonPlanSelector, groupId, params) {
  return (
    <div className={RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO}>
        <Tab
          id={`${INITIAL_ID_PLAN_SELECTOR_BUTTON_BLUE}${ROOT_ID_PLAN_SELECTOR_CARD}${idCardButtonRibbonPlanSelector}`}
          className={cls(`${RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO_TAB} ${RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO_TAB_ACTIVE} focusable`)}
      >
          <div className='container-button-include'>
              <ColoredButton
                  color="blue"
                  classSizeHotkey="large"
                  className={'access_option_button_blue'}
              >
                  <div className='button-include'>
                      {params.buttonInclude}
                  </div>
              </ColoredButton>
          </div>
      </Tab>
    </div>
  )
}

const getDataSnUpAndDown = (idsRibbonsUpAndDown, ribbonIndex, focusUpDefault, focusDownDefault) => {
  const haveIdsRibbonsUpAndDown = idsRibbonsUpAndDown && Object.keys(idsRibbonsUpAndDown).length > 0;
  const haveRibbonIndex = ribbonIndex !== undefined || ribbonIndex !== null;

  if(haveIdsRibbonsUpAndDown && haveRibbonIndex) {
    const { focusUp, focusDown} = idsRibbonsUpAndDown[ribbonIndex] || {};
    return { focusUp, focusDown}
  }

  return { focusUp: focusUpDefault, focusDown: focusDownDefault };
}


export default {
  getPlaceholder,
  getUri,

  createSibling,
  createTitle,
  createLabel,

  focusHandler,
  keyUpHandler,
  keyDownHandler,

  posterTitleIsEnabled,
  createBadge,
  createProgressBar,
  createFooter,
  createDeleteIcon,
  fillZeroLeft,
  getTimeProgress,
  createPlayerIcon,
  createSubTitle,

  createFooterPlanSelector,
  createButtonOfferPlanSelector,
  createLogoPlansAddOn,
  createButtonPlanSelector,
  createContainerTitlesPlanSelector,
  getRedirectPlanSelector,
  getDataSnUpAndDown
};



// WEBPACK FOOTER //
// ./src/components/CardNew/helpers.js